export default __webpack_public_path__ + "static/media/docClip.767ad1a8.svg";